import { createSlice } from '@reduxjs/toolkit';
const initialState = { error: false, redirectOnError: '' };
const slice = createSlice({
    name: 'redirect',
    initialState,
    reducers: {
        addRedirect: (state, action) => {
            state.error = action.payload.error;
            state.redirectOnError = action.payload.redirectOnError;
        },
    },
});
export const { addRedirect } = slice.actions;
export default slice;
